export enum MessageTypeEnum {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
  SIMPLE = 'simple',
}
